const CONSOLE_METHODS = [
  'debug',
  'info',
  'log',
  'warn',
  'error',
  'trace',
] as const;

const INSTALL_MARKER = Symbol.for('taratic.timestampedConsole.installed');
type TimestampedConsole = typeof console & { [INSTALL_MARKER]?: boolean };

export const installTimestampedConsole = (
  target: TimestampedConsole = console,
): void => {
  if (target[INSTALL_MARKER]) return;

  Object.defineProperty(target, INSTALL_MARKER, {
    value: true,
    enumerable: false,
    configurable: false,
  });

  for (const method of CONSOLE_METHODS) {
    const original = target[method].bind(target);
    target[method] = ((...args: unknown[]) => {
      original(`${new Date().toISOString()} |`, ...args);
    }) as TimestampedConsole[typeof method];
  }
};

installTimestampedConsole();
